import { RouteRecordRaw } from 'vue-router';
import { featureFlags } from '@/featureFlags';

export const TECH_EXPLORATION_DETAILS_PATH = '/tech-exploration/:uuid';

export const techExplorationRouteConfigs: RouteRecordRaw = {
  name: 'techExploration',
  path: '/tech-exploration',
  component: () =>
    featureFlags.ANDEV_10765_TECH_EXP_NEW_UX
      ? import('@/components/tech-exploration-next/layouts/main.vue')
      : import('@/components/tech-exploration/layouts/main.vue'),
  meta: { accessScope: 'tech_exploration' },
  children: [
    {
      path: '/tech-exploration/top',
      component: () =>
        import('@/components/tech-exploration/tech-exploration.vue'),
      name: 'techExplorationTop',
      meta: { title: '技術探索トップ', type: 'techExploration' },
    },
    {
      path: '/tech-exploration/settings',
      meta: { title: '技術探索設定', type: 'techExploration' },
      children: [
        {
          path: '',
          redirect: {
            name: 'techExplorationSettingsNotification',
          },
        },
        {
          path: 'notification',
          component: () =>
            import(
              '@/components-capability/tech-exploration/settings/notification-settings.vue'
            ),
          name: 'techExplorationSettingsNotification',
          meta: { title: '通知', type: 'techExploration' },
        },
        {
          path: 'news',
          component: () =>
            import('@/components/tech-exploration/settings/news-settings.vue'),
          name: 'techExplorationSettingsNews',
          meta: { title: '関連文献のタイトル翻訳', type: 'techExploration' },
        },
      ],
    },
    {
      path: TECH_EXPLORATION_DETAILS_PATH,
      name: 'techExplorationDetails',
      redirect: { name: 'techExplorationDetailsView' },
      meta: { type: 'techExploration' },
      children: [
        {
          path: '',
          component: () =>
            import(
              '@/components/tech-exploration/details/tech-exploration-details.vue'
            ),
          name: 'techExplorationDetailsView',
          meta: { title: '技術探索解決策', type: 'techExploration' },
        },
        {
          path: 'comparison',
          component: () =>
            import(
              '@/components/tech-exploration/details/tech-exploration-comparison.vue'
            ),
          name: 'techExplorationComparison',
          meta: { title: '解決策比較', type: 'techExploration' },
        },
        {
          path: 'definition',
          component: () =>
            import(
              '@/components/tech-exploration/details/tech-exploration-definition.vue'
            ),
          name: 'techExplorationDefinition',
          meta: { title: '課題の定義', type: 'techExploration' },
        },
      ],
    },
  ],
};
